<template>
  <FpSvgIcon
    :src="src"
    class="lenda-icon" 
    :width="width"
    :height="height"
  />
</template>

<script setup lang="ts">
import FpSvgIcon from '@/components/fpComponents/FpSvgIcon.vue';

const props = defineProps({
  src: {
    type: String,
    required: true,
  },
  width: {
    type: [Number, String],
  },
  height: {
    type: [Number, String],
  },
});
</script>

<style scoped lang="scss">
.lenda-icon {
  :deep(svg) {
    
    [fill]:not([fill="#22C7FA"]):not([fill="none"]):not([fill="transparent"]) {
      fill: var(--token-core-onCore-highEmphasis);
    }
    [stroke]:not([stroke="none"]):not([stroke="transparent"]) {
      stroke: var(--token-core-onCore-highEmphasis);
    }
  }
}
</style>